import React, { Fragment, useState, useEffect } from 'react';
import { Modal }                                from 'react-bootstrap';
import styled                                   from 'styled-components';
import loadable                                 from '@loadable/component';

/* Styles */
import styles from './Wrapper.module.css';

/* Storage */
import { retrieveMode, storeMode } from '../../helpers/storage';

/* Wrapper */
import WrapperConsumer from '../../store';

const ContentTwo = styled.div`
  min-width: 100%;
  padding-left: 0px;`

/* Components */
const Navbar      = loadable(() => import('../../Components/Navbar'));
const Toolbar     = loadable(() => import('../../Components/Toolbar'));

const Wrapper = (props) => {
  const {
    path,
    context: {
      modal,
      setIsMobile,
      setPathUrl,
      isToolbar, 
      setIsToolbar,
      nextView
    },
  } = props

  const [isNavBar, setIsNavBar]     = useState(false);
  const [loadWindow, setloadWindow] = useState(true);
  const [windowSize, setWindowSize] = useState(getWindowSize());

  function loadTimeInitial() {
    setloadWindow(false)
  }

  function getWindowSize() {
    setIsMobile(window.innerWidth < 1024)
    return window.innerWidth
  }

  function updateWindowSize() {
    setWindowSize(window.innerWidth)
    setIsMobile(window.innerWidth < 1024)
  }

  const routesPath = [
    '/onboarding/:view/:keyAct/:primaryKey/:tarjet'
  ]

  const listPath = [
    '/login',
    '/proceso-registro/:typeView'
  ]


  if (retrieveMode() === undefined || retrieveMode() === null ) {
    storeMode('light')
  }

  useEffect(() => {

    const root = window.document.documentElement;
    root.classList.remove(retrieveMode() === 'dark' ? 'light' : 'dark')
    root.classList.add(retrieveMode())

    setInterval(loadTimeInitial, 3000)

    setPathUrl(props.children.props.match.path)

    if (listPath.includes(props.children.props.match.path)) {
      setIsNavBar(true);
      document.body.classList.add('clarybody');
    }else if(routesPath.includes(props.children.props.match.path)){ 
      setIsToolbar(true);
      document.body.classList.add('clarybody');
    }else {
      setIsNavBar(false);
      document.body.classList.add('clarysplash');
    }

    window.addEventListener('resize', updateWindowSize)
    return () => {
      window.removeEventListener('resize', updateWindowSize)
    }
  }, [props.children.props.match.path, retrieveMode()])

  return (
    <Fragment>
      <Modal
        show={modal.showModal}
        onHide={modal.closeModal}
        dialogClassName={modal.customCss}
        size={modal.size}
        backdrop={modal.backdrop}
        centered
      >
        {modal.component}
      </Modal>

      {isNavBar === true ? (
        <div className='d-flex'>
          <div
            className={ `${styles.pageWrapper} bg-gradient-to-r from-degradado1 to-degradado1 dark:bg-bajioDark`}
          >
            <Navbar url={path} />
            <div className='' >
              <ContentTwo>{props.children}</ContentTwo>
            </div>
          </div>
        </div>
      ) :
      isToolbar === true ?
        <div className='d-flex'>
            <div
              className={ `${styles.pageWrapper} bg-gradient-to-r from-degradado1 to-degradado1 dark:bg-bajioDark`}
            >
              <Toolbar view={props.children.props.match.params} />
              <div className='' >
                <ContentTwo>{props.children}</ContentTwo>
              </div>
            </div>
        </div>
      :(
        <ContentTwo>{props.children}</ContentTwo>
      )}
    </Fragment>
  )
}

export default WrapperConsumer(Wrapper)
